export const BRASILIA_TIMEZONE = "America/Sao_Paulo";

/**
 * Converte data e horário informados na operação em um instante UTC preservando
 * o horário de Brasília, independentemente do fuso do navegador.
 */
export function fromBrasiliaDateTime(date: string, time: string): Date {
  const normalizedTime = time.length === 5 ? `${time}:00` : time;
  return new Date(`${date}T${normalizedTime}-03:00`);
}

export function brasiliaDateString(date = new Date()): string {
  return date.toLocaleDateString("en-CA", { timeZone: BRASILIA_TIMEZONE });
}

/**
 * Constrói o intervalo UTC do dia operacional selecionado. A data recebida
 * representa um dia escolhido na interface, portanto seus componentes UTC são
 * preservados antes de converter os limites para Brasília.
 */
export function brasiliaDayRangeFromSelectedDate(selectedDate: Date) {
  const year = selectedDate.getUTCFullYear();
  const month = String(selectedDate.getUTCMonth() + 1).padStart(2, "0");
  const day = String(selectedDate.getUTCDate()).padStart(2, "0");
  const date = `${year}-${month}-${day}`;

  return {
    start: fromBrasiliaDateTime(date, "00:00:00"),
    end: fromBrasiliaDateTime(date, "23:59:59"),
  };
}
